const initialState = {
  searchText: '',
  loading: false,
  foundDocumentation: [],
};

export default initialState;
